/**
 * Map Container Init
 *
 * @return {void}
 */
const init = () => {
	if ( !document.body ) {
		return;
	}
	const mapContainers = document.body.querySelectorAll( '.map-container' );

	if ( !mapContainers ) {
		return;
	}

	/**
	 * Google Map Action
	 *
	 * @param {Object} element container
	 *
	 * @returns {void}
	 */
	const displayMap = ( element ) => {
		const mapLat = element.getAttribute( 'data-lat' );
		const mapLng = element.getAttribute( 'data-lng' );
		const mapAddress = element.getAttribute( 'data-address' );
		const mapZoom = 13;
		const markerURL = element.getAttribute( 'data-marker-url' );

		// Bail if necessary values not present.
		if ( !mapLat || !mapLng || !mapAddress || !mapZoom ) {
			return;
		}

		// Get Position.
		let pos = new google.maps.LatLng( mapLat, mapLng );

		// GeoCoder.
		const geocoder = new google.maps.Geocoder();

		// Render Map.
		const map = new google.maps.Map( element, {
			center: pos,
			zoom: parseInt( mapZoom, 10 ),
			styles: [
				{
					elementType: 'labels.text.fill',
					stylers: [{color: '#929292'}]
				},
				{
					featureType: 'administrative',
					elementType: 'geometry',
					stylers: [{visibility: 'off'}
					]
				},
				{
					featureType: 'poi',
					stylers: [{visibility: 'off'}]
				},
				{
					featureType: 'road',
					elementType: 'labels.icon',
					stylers: [{visibility: 'off'}]
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.fill',
					stylers: [{color: '#dfdfdf'}]
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [{color: '#c2c2c2'}]
				},
				{
					featureType: 'transit',
					stylers: [{visibility: 'off'}]
				},
				{
					featureType: 'water',
					elementType: 'geometry.fill',
					stylers: [{color: '#c3dcfb'}]
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [{color: '#94b2db'}]
				}
			]
		} );

		const markerImage = new google.maps.MarkerImage( markerURL );

		// Render Marker.
		let marker = new google.maps.Marker( {
			map,
			draggable: false,
			animation: google.maps.Animation.DROP,
			anchorPoint: new google.maps.Point( 0, -29 ),
			position: pos
		} );

		// Make Responsive.
		google.maps.event.addDomListener( window, 'resize', () => {
			const center = map.getCenter();

			google.maps.event.trigger( map, 'resize' );
			map.setCenter( center );
		} );

		if ( geocoder ) {
			geocoder.geocode( {address: mapAddress},
				( results, status ) => {
					if ( status === google.maps.GeocoderStatus.OK ) {
						map.setCenter( results[0].geometry.location );
						marker.setVisible( false );

						// Get Position.
						pos = results[0].geometry.location;

						// Set marker on new position.
						marker = new google.maps.Marker( {
							map,
							position: pos
						} );
						marker.setIcon( markerImage );
					} else {
						console.alert( element.data( 'fail_alert' ) );
					}
				},
			);
		}
	};

	/**
	 * Google Map Activate
	 *
	 * @returns {void}
	 */
	const mapActivate = () => {
		mapContainers.forEach( ( element ) => {
			displayMap( element );
		} );
	};

	document.addEventListener( 'DOMContentLoaded', () => {
		mapActivate();
	} );
};

export default {init};
